import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    Box, Flex, Text, Heading, Button, SimpleGrid, useToast, 
    Link as ChakraLink, VStack, Center, Tag, Icon 
} from '@chakra-ui/react';
import { CreditCard, Zap, CheckCircle, ZapOff } from 'lucide-react'; 
import { loadStripe } from '@stripe/stripe-js'; 

const BACKEND_URL = process.env.REACT_APP_API_BASE_URL;
// **********************************************
// 🛑 DA MODIFICARE CON LE TUE CHIAVI E DATI REALI 🛑
// **********************************************

// 1. Chiave Pubblica Stripe
// Chiave pubblica Stripe (NON è la chiave segreta!)
const STRIPE_PUBLIC_KEY = 'pk_test_51SVf1YAU2DZpKfFMTAMtnUIMyXexvVWgEtbVS66Qz45sXr4IYhANYjXvAb6n66PH0zFgMhVyYNfTj8KRtGXJXY6L00fHi8OGch';

// Promessa per il caricamento di Stripe.js
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

// BillingPage.jsx - Modifica l'array plans (righe 20-24)

const plans = [
    { 
        name: "Base", 
        credits: 1000, 
        price: "€19/mese", 
        key: "plan_base", 
        features: ["1.000 crediti/mese", "Supporto via email", "Accesso alle API base"] // 🛑 AGGIUNTO
    },
    { 
        name: "Standard", 
        credits: 5000, 
        price: "€49/mese", 
        key: "plan_standard", 
        features: ["5.000 crediti/mese", "Supporto prioritario", "Accesso alle API avanzate"] // 🛑 AGGIUNTO
    },
    { 
        name: "Pro", 
        credits: 15000, 
        price: "€99/mese", 
        key: "plan_pro", 
        features: ["15.000 crediti/mese", "Supporto H24", "Funzionalità esclusive"] // 🛑 AGGIUNTO
    },
];

const topUpPackages = [ // 🛑 Assicurati che sia definito qui
    { credits: 500, price: "€9", key: "topup500" },
    { credits: 2000, price: "€29", key: "topup2000" },
    { credits: 5000, price: "€59", key: "topup5000" },
];
// **********************************************


const BillingPage = ({ user }) => {

// ... (altri stati)
const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
const [loadingPackageKey, setLoadingPackageKey] = useState(null);
// ...

    const toast = useToast();
    const navigate = useNavigate();


    const handlePurchase = async (pkg) => {
        setIsCheckoutLoading(true);
        setLoadingPackageKey(pkg.key); 
    const token = localStorage.getItem('token'); // Ottieni il token qui
 try {
  const response = await fetch(`${BACKEND_URL}/billing/create-checkout-session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ packageKey: pkg.key }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Errore nella creazione della sessione.');
  }

  const session = await response.json();

  // 🔑 Redirect diretto all'URL di Stripe
  window.location.href = session.url;

} catch (error) {
  console.error("Errore di acquisto:", error);
  toast({
    title: "Acquisto Fallito.",
    description: error.message,
    status: "error",
    duration: 5000,
    isClosable: true,
  });
  setIsCheckoutLoading(false);
  setLoadingPackageKey(null);
} 
};

    // Logica di gestione dei messaggi di successo/fallimento (come definita prima)
    useEffect(() => {
        // [Inserisci qui la funzione useEffect completa per gestire i parametri URL]
        // ... (omessa per brevità del codice, ma deve essere presente nel tuo file)
    }, [toast, navigate]);


    return (
     
        <Box minH="100vh" bg="gray.50" p={{ base: 4, md: 8 }} fontFamily="sans-serif">
           
            <Box maxW="6xl" mx="auto">
                <Heading as="h1" size="2xl" fontWeight="bold" color="indigo.700" mb={8} display="flex" alignItems="center">
                    <Icon as={CreditCard} w={8} h={8} mr={3} /> Gestione Piani e Ricariche
                </Heading>
                
                {/* 🛑 SEZIONE 0: STATO ATTUALE DEI CREDITI 🛑 */}
                <Box as="section" mb={10}>
                    <Heading as="h2" size="lg" fontWeight="bold" color="gray.800" mb={4}>I Tuoi Crediti Attuali</Heading>
                    <Flex bg="white" p={6} borderRadius="xl" shadow="md" align="center" justify="space-between">
                        <Flex align="center">
                            <Icon as={Zap} w={6} h={6} mr={3} color="indigo.500"/>
                            <Text fontSize="xl" fontWeight="medium">Crediti Rimanenti:</Text>
                        </Flex>
                        <Text fontSize="2xl" fontWeight="extrabold" color="indigo.600">
                            {user.remainingCredits}
                        </Text>
                        <Tag 
                            size="lg" 
                            variant="subtle" 
                            colorScheme={user.subscriptionPlan === 'Trial' ? 'red' : 'green'} 
                            ml={4}
                        >
                            Piano: {user.subscriptionPlan}
                        </Tag>
                    </Flex>
                </Box>
                
                {/* 🛑 SEZIONE 1: PIANI DI ABBONAMENTO (Mensili) 🛑 */}
                <Box as="section" mb={12}>
                    <Heading as="h2" size="xl" fontWeight="bold" color="gray.800" mb={4}>
                        Piani di Abbonamento (Mensili)
                    </Heading>
                    <Text color="gray.600" mb={6}>Scegli un piano per ricariche automatiche ogni mese e vantaggi aggiuntivi.</Text>
                    
                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={6}>
                        {plans.map((plan) => (
                            <VStack 
                                key={plan.key} 
                                bg="white" 
                                p={8} 
                                borderRadius="xl" 
                                shadow="xl" 
                                border="3px" 
                                // Evidenzia il piano attivo
                                borderColor={user.subscriptionPlan === plan.name ? 'indigo.500' : 'gray.200'}
                                transition="all 0.2s" 
                                spacing={4}
                                align="stretch"
                            >
                                <Center flexDirection="column">
                                    <Text fontSize="3xl" fontWeight="bold" color="indigo.700">{plan.name}</Text>
                                    <Text fontSize="5xl" fontWeight="extrabold" color="indigo.600">{plan.credits}</Text>
                                    <Text fontSize="lg" fontWeight="medium" color="gray.500">CREDITI / MESE</Text>
                                </Center>
                                
                                <Text fontSize="3xl" fontWeight="bold" color="gray.800" mt={4}>{plan.price}</Text>
                                
                                <VStack align="start" spacing={2} my={4}>
                                    {plan.features && plan.features.map((feature, index) => (
                                    <Flex key={index} align="center">
                                        <Icon as={CheckCircle} w={4} h={4} mr={2} color="green.500"/>
                                        <Text fontSize="sm">{feature}</Text>
                                    </Flex>
                                ))}
                                </VStack>

                                <Button
                                    onClick={() => handlePurchase(plan)} 
                                    w="full" 
                                    size="lg"
                                    // ... (altre props) ...
                                    isDisabled={user.subscriptionPlan === plan.name || (isCheckoutLoading && loadingPackageKey === plan.key)}
                                >
                                    {user.subscriptionPlan === plan.name ? 'Piano Attuale' : (
                                        isCheckoutLoading && loadingPackageKey === plan.key ? (
                                            // 💡 Stato di caricamento
                                            <Flex align="center" justify="center">
                                                <Icon as={Zap} w={4} h={4} mr={2} className="animate-spin" />
                                                Reindirizzamento...
                                            </Flex>
                                        ) : (
                                            'Scegli Piano'
                                        )
                                    )}
                                </Button>
                                
                                {user.subscriptionPlan === plan.name && <Text fontSize="xs" color="indigo.500">Crediti aggiornati automaticamente.</Text>}
                            </VStack>
                        ))}
                    </SimpleGrid>
                </Box>

                {/* 🛑 SEZIONE 2: RICARICHE CREDITI (Usa e Getta) 🛑 */}
                <Box as="section">
                    <Heading as="h2" size="xl" fontWeight="bold" color="gray.800" mb={4}>
                        Ricarica Crediti (Usa e Getta)
                    </Heading>
                    <Text color="gray.600" mb={6}>Acquista crediti extra in qualsiasi momento, validi per sempre.</Text>
                    
                    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={6}>
                        {topUpPackages.map((pkg) => (
                            <Box 
                                key={pkg.key} 
                                bg="white" 
                                p={6} 
                                borderRadius="xl" 
                                shadow="md" 
                                border="2px" 
                                borderColor="orange.200" 
                                _hover={{ shadow: 'lg' }} 
                                transition="all 0.2s" 
                                textAlign="center"
                            >
                                <Text fontSize="4xl" fontWeight="extrabold" color="orange.600">{pkg.credits}</Text>
                                <Text fontSize="md" fontWeight="medium" color="gray.500" mb={4}>CREDITI</Text>
                                
                                <Button
                                    onClick={() => handlePurchase(pkg)} 
                                    w="full" 
                                    py={2} 
                                    // ... (altre props) ...
                                    // Disabilita se un checkout è in corso (e se è questo pacchetto)
                                    isDisabled={isCheckoutLoading && loadingPackageKey === pkg.key}
                                >
                                    {isCheckoutLoading && loadingPackageKey === pkg.key ? (
                                        // 💡 Stato di caricamento (Reindirizzamento in corso)
                                        <Flex align="center" justify="center">
                                            <Icon as={Zap} w={4} h={4} mr={2} className="animate-spin" />
                                            Reindirizzamento...
                                        </Flex>
                                    ) : (
                                        `Acquista ${pkg.price}`
                                    )}
                                </Button>
                            </Box>
                        ))}
                    </SimpleGrid>
                </Box>
            </Box>
        </Box>
    );
};

export default BillingPage;